import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "../../../../../CustomHeadlessTable/CustomTable";
import {
  getWasteWater,
  addWasteToBusiness,
  updateWaste,
  deleteWaste,
} from "../../../../../../apis/Business/WasteApi";
import CustomInputComponent from "../../../../../CustomHeadlessTable/components/CustomInputComponent";

const WasteWaterTable = ({ businessId }) => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [dropdownUsedFor, setDropdownUsedFor] = useState([
    {
      id: 1,
      name: t("WASTE_WATER"),
      value: t("WASTE_WATER"),
      type: t("WASTE_WATER"),
      unit: "kg",
      typeDB: "waste_water",
      key: "WASTE_WATER",
    },
    {
      id: 2,
      name: t("RAIN_WATER"),
      value: t("RAIN_WATER"),
      type: t("RAIN_WATER"),
      unit: "L",
      typeDB: "rain_water",
      key: "RAIN_WATER",
    },
    {
      id: 3,
      name: t("MELT_WATER"),
      value: t("MELT_WATER"),
      type: t("MELT_WATER"),
      unit: "L",
      typeDB: "melt_water",
      key: "MELT_WATER",
    },
    {
      id: 4,
      name: t("DRAINAGE_WATER"),
      value: t("DRAINAGE_WATER"),
      type: t("DRAINAGE_WATER"),
      unit: "L",
      typeDB: "drainage_water",
      key: "DRAINAGE_WATER",
    },
    {
      id: 4,
      name: t("WELL_WATER"),
      value: t("WELL_WATER"),
      type: t("WELL_WATER"),
      unit: "L",
      typeDB: "well_water",
      key: "WELL_WATER",
    },
  ]);

  useEffect(() => {
    setDropdownUsedFor([
      {
        id: 1,
        name: t("WASTE_WATER"),
        value: t("WASTE_WATER"),
        type: t("WASTE_WATER"),
        unit: "kg",
        typeDB: "waste_water",
        key: "WASTE_WATER",
      },
      {
        id: 2,
        name: t("RAIN_WATER"),
        value: t("RAIN_WATER"),
        type: t("RAIN_WATER"),
        unit: "L",
        typeDB: "rain_water",
        key: "RAIN_WATER",
      },
      {
        id: 3,
        name: t("MELT_WATER"),
        value: t("MELT_WATER"),
        type: t("MELT_WATER"),
        unit: "L",
        typeDB: "melt_water",
        key: "MELT_WATER",
      },
      {
        id: 4,
        name: t("DRAINAGE_WATER"),
        value: t("DRAINAGE_WATER"),
        type: t("DRAINAGE_WATER"),
        unit: "L",
        typeDB: "drainage_water",
        key: "DRAINAGE_WATER",
      },
      {
        id: 4,
        name: t("WELL_WATER"),
        value: t("WELL_WATER"),
        type: t("WELL_WATER"),
        unit: "L",
        typeDB: "well_water",
        key: "WELL_WATER",
      },
    ]);
  }, [t]);
  const [buyerOptions, setBuyerOptions] = useState([]);

  const toggleColumnVisibility = useCallback((columnId) => {
    setHiddenColumns((prev) =>
      prev.includes(columnId)
        ? prev.filter((id) => id !== columnId)
        : [...prev, columnId]
    );
  }, []);

  const fetchData = useCallback(() => {
    getWasteWater({
      businessId: businessId,
      setObjects: setData,
      category: "water",
      setBuyerOptions: setBuyerOptions,
    });
  }, [businessId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleEdit = useCallback(
    (editedItem) => {
      updateWaste({
        businessId,
        objectId: editedItem.id,
        ...editedItem,
        category: "water",
        type_waste_water: editedItem["type_waste_water.value"]
          ? editedItem["type_waste_water.value"].value
          : editedItem["type_waste_water"]
          ? editedItem["type_waste_water"].value
          : null,
        type_surplus_energy: null,
        type_surplus_material: null,
        type_current_disposal: null,
        objects: data,
        setObjects: setData,
        use_swal: true,
      });
    },
    [businessId, data, setData]
  );

  const handleAdd = useCallback(
    (newItem) => {
      addWasteToBusiness({
        businessId,
        ...newItem,
        category: "water",
        type_waste_water: newItem["type_waste_water.value"]
          ? newItem["type_waste_water.value"].value
          : null,
        type_surplus_energy: null,
        type_surplus_material: null,
        type_current_disposal: null,
        callback: fetchData,
        use_swal: true,
      });
    },
    [businessId, fetchData]
  );

  const handleDelete = useCallback(
    (itemToDelete) => {
      deleteWaste({
        businessId,
        objectId: itemToDelete.id,
        callback: fetchData,
      });
    },
    [businessId, fetchData]
  );

  const columns = useMemo(
    () => [
      {
        accessor: "invoice_date",
        header: t("INVOICE_DATE"),
        type: "text",
        canHide: true,
        canSort: true,
        placeholder: t("DD_MM_YYYY"),
        optional: true,
        width: "80px",
      },
      {
        accessor: "invoice_number",
        header: t("INVOICE_NO"),
        type: "text",
        canSort: true,
        canHide: true,
        optional: true,
        width: "80px",
      },
      {
        accessor: "nickname",
        header: t("NICKNAME"),
        type: "text",
        disableSortBy: true,
        placeholder: "0",
        width: "80px",
      },
      {
        accessor: "type_waste_water.value",
        header: `${t("TYPE_WASTE_WATER")}*`,
        type: "dropdown",
        dropdownData: dropdownUsedFor,
        disableSortBy: true,
        width: "110px",
        optional: true,
      },

      {
        accessor: "total_waste_water",
        header: `${t("QUANTITY")}*`,
        type: "number",
        disableSortBy: true,
        placeholder: t("WASTE_QTY"),
        width: "80px",
        optional: true,
      },

      {
        accessor: "spacer1",
        header: "",
        type: "spacer",
        width: "20px",
        optional: true,
        disableSortBy: true,
      },
      {
        accessor: "price_invoice",
        header: t("PRICE_INVOICE"),
        type: "number",
        canSort: true,
        canHide: true,
        placeholder: "0",
        optional: true,
        subtotalUnit: "DKK",
        width: "80px",
        tipHeader: "Tip",
        tipBody: t("PRICE_INVOICE_TIP"),
      },
      {
        accessor: "carbon",
        header: t("EMISSION_WASTE_WATER"),
        type: "custom",
        canSort: true,
        cell: ({ value }) => {
          return <CustomInputComponent value={value} readOnly />;
        },
        optional: true,
        subtotalUnit: "tCO₂e",
        subtotalFixed: true,
        width: "80px",
      },
      {
        accessor: "spacer2",
        header: "",
        type: "spacer",
        width: "20px",
        optional: true,
        disableSortBy: true,
      },
      {
        accessor: "share",
        header: t("SHARE"),
        type: "checkbox",
        wide: false,
        width: "50px",
        tipHeader: "Tip",
        tipBody: t("TIPBOX_WASTE_SELL"),
        optional: true,
        disableSortBy: true,
      },
      {
        accessor: "buyer",
        header: t("BUYER"),
        type: "buyerInput",
        buyerOptions: buyerOptions,
        width: "100px",
        optional: true,
      },
      {
        accessor: "water_sold",
        header: t("QTY_SOLD_MATERIALS"),
        type: "number",
        disableSortBy: true,
        placeholder: "0",
        width: "80px",
        optional: true,
      },
      {
        accessor: "avoided_emission",
        header: t("AVOIDED_EMISSIONS"),
        type: "custom",
        canSort: true,
        cell: ({ value }) => {
          return <CustomInputComponent value={value} readOnly />;
        },
        optional: true,
        subtotalUnit: "tCO₂e",
        subtotalFixed: true,
        width: "80px",
      },
    ],
    [dropdownUsedFor, buyerOptions, t]
  );

  const disableRules = {
    carbon: () => true,
    avoided_emission: () => true,
    water_sold: () => true,
    buyer: () => true,
    share: () => true,
  };

  const subtotalColumns = {
    price_invoice: { label: t("TOTAL_PRICE") },
    carbon: { label: t("TOTAL_CARBON") },
    avoided_emission: { label: t("AVOIDED_EMISSIONS") },
  };

  const memoizedDropdownData = useMemo(
    () => ({
      "type_waste_water.value": dropdownUsedFor,
    }),
    [dropdownUsedFor]
  );

  return (
    <CustomTable
      columns={columns}
      data={data}
      setData={setData}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      dropdownData={memoizedDropdownData}
      subtotalColumns={subtotalColumns}
      customInputs={{
        carbon: CustomInputComponent,
        avoided_emission: CustomInputComponent,
      }}
      hiddenColumns={hiddenColumns}
      toggleColumnVisibility={toggleColumnVisibility}
      disableRules={disableRules}
    />
  );
};

export default WasteWaterTable;
